import React from 'react'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import EditOrCreateFoodRestriction from '@/features/food-restrictions/EditOrCreateFoodRestriction'

export const Route = createFileRoute('/food-restrictions/$restrictionId')({
  component: EditFoodRestrictions,
})

function EditFoodRestrictions() {
  const params = Route.useParams()
  const navigate = useNavigate()

  return <EditOrCreateFoodRestriction restrictionId={params.restrictionId} navigate={navigate} />
}
